<template>
  <footer>
    <div class="bg-blue-900 relative">
      <div class="py-6 container m-auto lg:px-12 xl:px-16 relative">

        <div class="app-links p-4 mb-6 hidden lg:block lg:absolute top-0 right-0 rounded-b-lg lg:mr-12 xl:mr-16">
          <div class="flex">

            <div class="flex flex-col items-center text-center pr-2">
              <p class="text-white font-semibold text-sm mb-1 text-center">{{ $t('messages.general.download_app_title')}}</p>
              <a href="https://play.google.com/store/apps/details?id=com.jwperfectmatch.android" target="_blank" rel="nofollow">
                <img alt="jehovah's witnesses dating site android app" src="/storage/image/google.png" class="w-20 h-6" />
              </a>
            </div>
            <div class="flex flex-col items-center border-l pl-2">
              <p class="text-white font-semibold text-sm mb-1 text-center">{{ $t('messages.general.coming_app_title')}}</p>
              <a href="/" target="_blank" rel="nofollow">
                <img alt="jehovah's witnesses dating site ios" src="/storage/image/apple.png" class="w-20 h-6" />
              </a>
            </div>

          </div>
        </div>

        <div class="flex justify-start flex-col lg:flex-row items-center ml-0 lg:ml-10 my-4">
          <img class="w-16 mr-0 mb-8 lg:mb-0 lg:mr-10" src="/storage/image/heart.png" alt="jw dating heart icon" />
          <div class="menu-container">
            <span
              class="text-base text-white font-extrabold text-center"
            >
              <img class="h-auto w-auto" src="/storage/image/footer_legend.png" alt="Jehovah's Witnesses dating site" />
            </span>
            <ul class="list-reset flex justify-center items-center flex-col lg:flex-row p-0 py-3 text-sm lg:text-base">
              <li class="py-2 lg:py-0">
                <router-link
                  class="text-blue-250 hover:text-jblue-secondary no-underline font-normal text-base mr-0 lg:mr-4"
                  to="/support"
                  rel="nofollow"
                >{{ $t('messages.general.support') }}</router-link>
              </li>
              <li class="py-2 lg:py-0">
                <router-link
                  class="text-blue-250 hover:text-jblue-secondary no-underline font-normal text-base px-4"
                  to="/security"
                  rel="nofollow"
                >{{ $t('messages.general.security') }}</router-link>
              </li>
              <li class="py-2 lg:py-0">
                <router-link
                  class="text-blue-250 hover:text-jblue-secondary no-underline font-normal text-base px-4"
                  to="/privacy"
                  rel="nofollow"
                >{{ $t('messages.general.privacy') }}</router-link>
              </li>
              <li class="py-2 lg:py-0">
                <router-link
                  class="text-blue-250 hover:text-jblue-secondary no-underline font-normal text-base px-4"
                  to="/terms-conditions"
                  rel="nofollow"
                >{{ $t('messages.general.terms') }}</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="ml-0 flex justify-center lg:justify-end items-center">
          <div class="w-1/2 ml-0 lg:ml-10 pl-16">
            <img
              src="/storage/image/silverant-logo.png"
              alt="silverant"
              class="w-32 lg:ml-0 lg:ml-10"
            />
          </div>
          <div class="w-1/2 flex justify-end">
            <div ref="nortonicon"></div>
            <div id="gist"></div>
            <div id="gist2"></div>
            <div id="DigiCertClickID_TxiTQxQj"></div>
            <div v-html="html"></div>
          </div>
        </div>
      </div>
      <div class="bg-jblue-footer">
        <div class="container mx-auto lg:px-12 xl:px-16 flex items-center justify-between flex-col lg:flex-row py-2">
          <p
            class="text-white font-normal text-base ml-10 hidden lg:block"
          >{{ getYear }} JWperfectmatch. {{ $t('messages.general.rights') }}</p>
          <ul
            class="list-reset flex justify-center items-center flex-col lg:flex-row p-0 mb-6 lg:mb-0 text-sm lg:text-base list-footer-bottom"
          >
            <li class="py-2 lg:py-0">
              <router-link
                class="text-white no-underline font-normal text-base lg:px-4 hover:text-blue-500"
                to="/guidance"
                rel="nofollow"
              >{{ $t('messages.general.tips') }}</router-link>
            </li>
            <li class="py-2 lg:py-0">
              <router-link
                class="text-white no-underline font-normal text-base border-transparent lg:border-blue-500 lg:px-4 hover:text-blue-500"
                to="/jw-dating"
              >{{ $t('messages.general.engagement') }}</router-link>
            </li>
            <li class="py-2 lg:py-0">
              <router-link
                class="text-white no-underline font-normal text-base border-transparent lg:border-blue-500 hover:text-blue-500 lg:pl-4"
                to="/conduct"
                rel="nofollow"
              >{{ $t('messages.general.conduct') }}</router-link>
            </li>
          </ul>

          <div class="flex justify-between app-links p-4 mb-6 lg:hidden lg:absolute top-0 right-0 rounded-b-lg lg:mr-12 xl:mr-16">
            <div class="flex flex-col items-center text-center pr-2">
              <p class="text-white font-semibold text-sm mb-1 text-center">{{ $t('messages.general.download_app_title')}}</p>
              <a href="https://play.google.com/store/apps/details?id=com.jwperfectmatch.android" target="_blank" rel="nofollow">
                <img alt="jehovah's witnesses dating site android app" src="/storage/image/google.png" class="w-20 h-6" />
              </a>
            </div>
            <div class="flex flex-col items-center border-l pl-2">
              <p class="text-white font-semibold text-sm mb-1 text-center">{{ $t('messages.general.coming_app_title')}}</p>
              <a href="/" target="_blank" rel="nofollow">
                <img alt="jehovah's witnesses dating site ios" src="/storage/image/apple.png" class="w-20 h-6" />
              </a>
            </div>
          </div>

          <ul class="list-reset justify-around w-full items-center flex lg:hidden mb-6 px-12">
            <li class="no-underline">
              <a
                href="https://www.facebook.com/JW-Perfectmatch-107173767616233/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/storage/image/facebook.svg" class="w-8 h-8 object-contain" alt="jw dating facebook">
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/jwperfectmatch"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/storage/image/instagram.svg" class="w-8 h-8 object-contain" alt="jw dating instagram">
              </a>
            </li>
            <li>
              <a href="https://twitter.com/jwperfectmatch" target="_blank">
                <img src="/storage/image/twitter.svg" class="w-8 h-8 object-contain" alt="jw dating twitter">
              </a>
            </li>
          </ul>
          <p
            class="text-white font-normal text-base block lg:hidden text-center"
          >{{ getYear }} JWperfectmatch. {{ $t('messages.general.rights') }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import postscribe from 'postscribe';
import axios from 'axios';

export default {
  name: "Footer",
  data() {
    return {
      isRegister: false,
      html: null
    };
  },
  async mounted() {

    postscribe("#DigiCertClickID_TxiTQxQj",
      `<script type="text/javascript">
          var __dcid = __dcid || [];
          __dcid.push({"cid":"DigiCertClickID_TxiTQxQj","tag":"TxiTQxQj"});
          (function(){var cid=document.createElement("script");cid.async=true;cid.src="//seal.digicert.com/seals/cascade/seal.min.js";var s = document.getElementsByTagName("script");var ls = s[(s.length - 1)];ls.parentNode.insertBefore(cid, ls.nextSibling);}());
        <\/script>`
    );
  },
  computed: {
    getYear() {
      return new Date().getFullYear();
    }
  }
};
</script>
<style lang="scss">
.container-app {
  border-radius: 0px 0px 0px 50px;
  .store-link {
    max-width: 100px;
  }
}

.app-links {
  @media only screen and (min-width: 1024px) {
    background: linear-gradient(90deg, #1C4C91 0%, #3A91F9 100%);
  }
}

.text-blue-250 {
  color: #9BC9FF;
}

.mb--6 {
  margin-bottom: -1.5em;
}

.bg-jblue-footer {
  background-color: #1C4C91;
}

.register-footer {
  .list-footer-bottom {
    padding-right: 2.5rem;
  }

  .list-footer-social {
    margin-right: 2.5rem;
  }

  .app-links {
    margin-right: 2.5rem;
    padding: 5px;
  }
}
</style>
